<div class="pb-28">
  @if (isLoading) {
    <!-- Squelettes : la place des lignes est gardée pendant le chargement -->
    <div class="flex flex-col gap-3" aria-hidden="true">
      @for (i of [1, 2, 3]; track i) {
        <div class="h-[80px] w-full animate-pulse rounded-2xl bg-vw-surface-sunk"></div>
      }
    </div>
  } @else if (failed) {
    <vw-error-state (retry)="retry()"></vw-error-state>
  } @else if (seeds.length === 0) {
    <!-- Aucune graine : Willy, une phrase d'utilité, les deux chemins -->
    <div class="flex flex-col items-center gap-2 px-4 py-6 text-center" data-test="empty">
      <img src="/assets/images/willy/willy_book.png" alt="" class="mb-2 h-32 w-32 object-contain">
      <h2 class="text-title-l text-vw-ink">{{ 'garden.seeds.empty.title' | translate }}</h2>
      <p class="text-body text-vw-body">{{ 'garden.seeds.empty.text' | translate }}</p>
      <div class="mt-4 flex w-full flex-col items-center gap-3">
        <vw-button [label]="'garden.seeds.add-sheet.scan.title'" [look]="'primary'" [iconTemplate]="scanIcon" (onClick)="onScan()"></vw-button>
        <vw-button [label]="'garden.seeds.add-sheet.catalog.title'" [look]="'secondary'" [iconTemplate]="searchIcon" (onClick)="onSearchCatalog()"></vw-button>
      </div>
      <ng-template #scanIcon><vw-scan-barcode-icon class="block h-5 w-5 [&>svg]:h-5 [&>svg]:w-5"></vw-scan-barcode-icon></ng-template>
      <ng-template #searchIcon><vw-search-icon class="block h-5 w-5"></vw-search-icon></ng-template>
    </div>
  } @else {
    <!-- Ajouter des graines : la même feuille que le « + » -->
    <button type="button" (click)="showAddSheet = true"
      class="flex min-h-btn w-full items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-vw-line-strong text-body font-semibold text-vw-primary active:bg-vw-surface-sunk">
      <vw-plus-icon class="block h-5 w-5"></vw-plus-icon>
      {{ 'garden.seeds.add' | translate }}
    </button>

    <!-- Entrée du plan de saison, du 8 février au 31 mars (K21) -->
    <vw-season-plan-banner class="mt-4 block"></vw-season-plan-banner>

    @if (nowSeeds.length) {
      <h2 class="mt-6 text-title-m text-vw-ink">{{ 'garden.seeds.sections.now' | translate }}</h2>
      <div class="mt-2 divide-y divide-vw-line overflow-hidden rounded-2xl bg-vw-surface shadow-lg">
        @for (seed of nowSeeds; track seed.uid) {
          <vw-seed-item class="block" [seed]="seed" [timing]="timingOf(seed)" [showChevron]="false" (click)="onSelectSeedDetails(seed)">
            <vw-button seedAction size="small" [look]="'quiet'"
              [label]="timingOf(seed)?.kind === 'plant' ? 'garden.seeds.plant' : 'garden.seeds.sow'"
              (click)="$event.stopPropagation()" (onClick)="onPlantSeed(seed)"></vw-button>
          </vw-seed-item>
        }
      </div>
    }

    @if (packetSeeds.length) {
      <div class="mt-6 flex items-baseline justify-between">
        <h2 class="text-title-m text-vw-ink">{{ 'garden.seeds.sections.seeds' | translate }}</h2>
        <span class="text-body-s text-vw-muted">{{ 'garden.seeds.varieties' | vwPlural: packetSeeds.length }}</span>
      </div>
      <div class="mt-2 divide-y divide-vw-line overflow-hidden rounded-2xl bg-vw-surface shadow-lg">
        @for (seed of packetSeeds; track seed.uid) {
          <vw-seed-item class="block" [seed]="seed" [timing]="timingOf(seed)" (click)="onSelectSeedDetails(seed)"></vw-seed-item>
        }
      </div>
    }

    @if (bulbSeeds.length) {
      <div class="mt-6 flex items-baseline justify-between">
        <h2 class="text-title-m text-vw-ink">{{ 'garden.seeds.sections.bulbs' | translate }}</h2>
        <span class="text-body-s text-vw-muted">{{ 'garden.seeds.varieties' | vwPlural: bulbSeeds.length }}</span>
      </div>
      <div class="mt-2 divide-y divide-vw-line overflow-hidden rounded-2xl bg-vw-surface shadow-lg">
        @for (seed of bulbSeeds; track seed.uid) {
          <vw-seed-item class="block" [seed]="seed" [timing]="timingOf(seed)" (click)="onSelectSeedDetails(seed)"></vw-seed-item>
        }
      </div>
    }

    <!-- Charger à la demande plutôt qu'au défilement : la barre de navigation
         est juste en dessous (même choix que les conseils). -->
    @if (hasMore) {
      <div class="mt-6 flex justify-center">
        <vw-button [look]="'secondary'" [loading]="isLoadingMore" [label]="'garden.seeds.load-more'" (onClick)="loadMore()"></vw-button>
      </div>
    }
  }

  <vw-seed-actions-toast [isOpen]="showAddSheet" (close)="showAddSheet = false"></vw-seed-actions-toast>
</div>
